module.exports = __webpack_public_path__ + "img/download.ce19001a.png";